import basicPins from './basic-pins';
import trafficSigns from './traffic-signs';
import UKRoadSigns from './uk-road-signs';
import packageObjects from './package_objects';
import packageSigns from './package_signs';

const tagTextures = {
  ...basicPins,
  ...trafficSigns,
  ...UKRoadSigns,
  ...packageObjects,
  ...packageSigns
};

export const defaultTagTexture = Object.keys(tagTextures)[0];

export const getTagTexturePath = (key) => {
  return tagTextures[key];
};

export default tagTextures;
